import React, { useState, useEffect } from 'react';
import {  Zap, Droplets } from 'lucide-react';
import dizzeeLogo from './Dizzee Logo_page-0001.jpg';
import liquidImage from './Liquid.jpg';
import handWashImage from './hand wash.png';

export default function DizzeePage() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  // const [likedProducts, setLikedProducts] = useState(new Set());

  // const products = [
  //   {
  //     id: 'dishwash-gel',
  //     name: 'Dish Wash Gel',
  //     category: 'DISHWASH GELS',
  //     description: 'Powerful grease-cutting formula that removes tough stains while being gentle on hands',
  //     features: [
  //       { title: 'Tough on Grease', description: 'Removes tough stains and grease', color: 'orange', icon: Zap },
  //       { title: 'Removes Bad Odors', description: 'Eliminates unpleasant smells', color: 'blue', icon: Shield },
  //       { title: 'Gentle on Hands', description: 'Safe and mild for daily use', color: 'green', icon: Heart },
  //       { title: 'Sparkling Clean', description: 'Leaves dishes spotless and streak-free', color: 'purple', icon: Award }
  //     ],
  //     sizes: [
  //       { size: '250ml', type: 'Regular Pack', color: 'orange', price: '₹75' },
  //       { size: '500ml', type: 'Family Pack', color: 'blue', price: '₹140', popular: true }
  //     ],
  //     ingredients: [
  //       'Sodium Lauryl Ether Sulfate',
  //       'Linear Alkyl Benzene Sulphonic Acid',
  //       'Sodium Hydroxide',
  //       'Sodium Chloride',
  //       'Perfume',
  //       'Color'
  //     ],
  //     gradient: 'from-orange-50 via-white to-blue-50/30',
  //     badgeColor: 'orange',
  //     primaryColor: 'orange',
  //     secondaryColor: 'blue',
  //     rating: 4.8,
  //     reviews: 1247,
  //     washes: '100+',
  //     loadType: 'All Dish Types'
  //   },
  //   {
  //     id: 'hand-wash',
  //     name: 'Hand Wash',
  //     category: 'HAND WASH',
  //     description: 'Antibacterial hand wash for effective cleaning and protection',
  //     features: [
  //       { title: 'Antibacterial Protection', description: 'Eliminates 99.9% of germs and bacteria', color: 'blue', icon: Shield },
  //       { title: 'Moisturizing Formula', description: 'Keeps hands soft and hydrated', color: 'green', icon: Heart },
  //       { title: 'Gentle on Skin', description: 'Suitable for sensitive skin', color: 'purple', icon: Award },
  //       { title: 'Refreshing Scents', description: 'Multiple pleasant fragrance options', color: 'orange', icon: Star }
  //     ],
  //     sizes: [
  //       { size: '250ml', type: 'Regular Pack', color: 'blue', price: '₹75' },
  //       { size: '500ml', type: 'Family Pack', color: 'green', price: '₹140', popular: true }
  //     ],
  //     gradient: 'from-blue-50 via-white to-green-50/30',
  //     badgeColor: 'blue',
  //     primaryColor: 'blue',
  //     secondaryColor: 'green',
  //     rating: 4.6,
  //     reviews: 634
  //   }
  // ];

  // const getColorClasses = (color) => {
  //   const colors = {
  //     orange: { bg: 'bg-orange-100', border: 'border-orange-200', text: 'text-orange-900', badge: 'bg-orange-100', badgeText: 'text-orange-800' },
  //     blue: { bg: 'bg-blue-100', border: 'border-blue-200', text: 'text-blue-900', badge: 'bg-blue-100', badgeText: 'text-blue-800' },
  //     green: { bg: 'bg-green-100', border: 'border-green-200', text: 'text-green-900', badge: 'bg-green-100', badgeText: 'text-green-800' },
  //     purple: { bg: 'bg-purple-100', border: 'border-purple-200', text: 'text-purple-900', badge: 'bg-purple-100', badgeText: 'text-purple-800' },
  //     pink: { bg: 'bg-pink-100', border: 'border-pink-200', text: 'text-pink-900', badge: 'bg-pink-100', badgeText: 'text-pink-800' }
  //   };
  //   return colors[color] || colors.blue;
  // };

  // const toggleLike = (productId) => {
  //   const newLikedProducts = new Set(likedProducts);
  //   if (newLikedProducts.has(productId)) {
  //     newLikedProducts.delete(productId);
  //   } else {
  //     newLikedProducts.add(productId);
  //   }
  //   setLikedProducts(newLikedProducts);
  // };

  // const renderStars = (rating) => {
  //   return Array.from({ length: 5 }, (_, i) => (
  //     <Star
  //       key={i}
  //       className={`w-3 h-3 ${i < Math.floor(rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`}
  //     />
  //   ));
  // };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white py-12">
      {/* Hero Section */}
      <section className="relative py-12 bg-gradient-to-br from-orange-50 via-white to-blue-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center text-center space-y-8">
            
            {/* Main heading */}
            <div className="space-y-4 py-12">
              <h1 className="text-5xl sm:text-6xl font-bold text-gray-900 leading-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-blue-600">DIZZEE</span>
              </h1>
            </div>

            {/* Dizzee Logo */}
            <div className="relative w-full max-w-md">
              <div className="bg-white rounded-2xl p-8">
                <img 
                  src={dizzeeLogo} 
                  alt="Dizzee Logo" 
                  className="w-full h-full object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="hidden items-center justify-center h-full w-full">
                  <span className="text-xl font-bold text-gray-700 text-center">Dizzee Logo</span>
                </div>
              </div>
            </div>

            {/* Product Categories */}
            <div className="text-center">
              <div className="flex flex-wrap justify-center gap-4">
                <div className="px-4 py-2 bg-orange-50 rounded-full border border-orange-200">
                  <span className="text-sm font-semibold text-orange-700">DISHWASH GELS</span>
                </div>
                <div className="px-4 py-2 bg-blue-50 rounded-full border border-blue-200">
                  <span className="text-sm font-semibold text-blue-700">HAND WASH</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 via-white to-orange-50/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-left mb-20">
            <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-100 to-blue-100 px-4 py-2 rounded-full mb-6">
              <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
              <span className="text-sm font-semibold text-orange-700">Premium Collection</span>
            </div>
            <h2 className="text-5xl sm:text-6xl font-bold text-gray-900 mb-8">
              Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-blue-600">Products</span>
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-orange-500 to-blue-500 rounded-full mb-10"></div>
            <p className="text-xl text-gray-600 max-w-4xl leading-relaxed">
              Discover the advanced technology and premium ingredients that make Dizzee Wash the perfect choice for your dishwashing needs
            </p>
          </div>

          {/* Product Cards */}
          <div className="space-y-24">
            
            {/* Dish Wash Gel Card */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-orange-100 to-blue-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-orange-700">DISHWASH GELS</span>
                      </div>
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Dish Wash Gel</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                          Our Dish Wash Gel is a powerful, grease-cutting formula that removes tough stains while being gentle on hands. With a refreshing fragrance and rich foam, it ensures spotless, streak-free dishes using just a small amount. Eco-friendly and safe, it's perfect for homes and commercial kitchens, leaving your utensils sparkling clean with every wash.
                        </p>
                      </div>

                      {/* Sizes Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-orange-50 to-blue-50 rounded-xl">
                          <span className="text-2xl font-bold text-orange-600 block">500ml</span>
                          <span className="text-sm text-gray-500">Family Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-orange-50 rounded-xl">
                          <span className="text-2xl font-bold text-blue-600 block">250ml</span>
                          <span className="text-sm text-gray-500">Regular Pack</span>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Tough on grease and stains</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Removes bad odors</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Gentle on hands</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Leaves dishes sparkling clean</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-pink-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Instant clean</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Citrus plus</span>
                        </div>
                      </div>

                      {/* Ingredients */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Ingredients</h4>
                        <p className="text-sm text-gray-600">
                          Sodium Lauryl Ether Sulfate, Linear Alkyl Benzene Sulphonic Acid, Sodium Hydroxide, Sodium Chloride, Perfume, Color
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Image */}
                  <div className="bg-gradient-to-br from-orange-50 via-white to-blue-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 ">
                        <img 
                          src={liquidImage} 
                          alt="Dizzee Dish Wash Gel" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Hand Wash Card */}
            <div className="relative">
              <div className="bg-white rounded-3xl border border-gray-200 overflow-hidden">
                <div className="grid xl:grid-cols-2 min-h-[600px]">
                  
                  {/* Left Side - Image */}
                  <div className="bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center p-12">
                    <div className="relative w-full max-w-md">
                      <div className="bg-white rounded-2xl p-8 ">
                        <img 
                          src={handWashImage} 
                          alt="Dizzee Hand Wash" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right Side - Content */}
                  <div className="p-12 flex flex-col justify-center">
                    <div className="space-y-8">
                      {/* Product Badge */}
                      <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-100 to-green-100 px-4 py-2 rounded-full">
                        <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                        <span className="text-sm font-semibold text-blue-700">HAND WASH</span>
                      </div>
                      
                      {/* Product Title */}
                      <div>
                        <h3 className="text-4xl font-bold text-gray-900 mb-4">Hand Wash</h3>
                        <p className="text-lg text-gray-600 leading-relaxed">
                          Our Dizzee Handwash provides gentle yet effective cleansing, removing 99.9% of germs while keeping hands soft and moisturized. Its mild, skin-friendly formula lathers well, leaving hands fresh, clean, and lightly scented after every wash. Safe for daily use, it offers the perfect balance of hygiene and care.
                        </p>
                      </div>

                      {/* Sizes Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-green-50 rounded-xl">
                          <span className="text-2xl font-bold text-blue-600 block">500ml</span>
                          <span className="text-sm text-gray-500">Family Pack</span>
                        </div>
                        <div className="text-center p-4 bg-gradient-to-br from-green-50 to-blue-50 rounded-xl">
                          <span className="text-2xl font-bold text-green-600 block">250ml</span>
                          <span className="text-sm text-gray-500">Regular Pack</span>
                        </div>
                      </div>

                      {/* Features Grid */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Antibacterial Protection</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Moisturizing Formula</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Gentle on Skin</span>
                        </div>
                        <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                          <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                          <span className="text-sm font-medium text-gray-700">Refreshing Scents</span>
                        </div>
                      </div>

                      {/* Ingredients */}
                      <div>
                        <h4 className="text-lg font-semibold text-gray-800 mb-3">Premium Ingredients</h4>
                        <p className="text-sm text-gray-600">
                          Water, Sodium Lauryl Sulfate, Cocamidopropyl Betaine, Glycerin, Fragrance, Preservatives, Color
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-lg w-full max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-bold text-gray-900">{selectedProduct.name}</h3>
                <button 
                  onClick={() => setSelectedProduct(null)}
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  <span className="text-xl">×</span>
                </button>
              </div>
              
              <div className="space-y-4">
                <p className="text-sm text-gray-600">{selectedProduct.longDescription}</p>
                
                {selectedProduct.ingredients && (
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 text-sm">Ingredients:</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {selectedProduct.ingredients.map((ingredient, idx) => (
                        <div key={idx} className="text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">
                          {ingredient}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {selectedProduct.washes && (
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2">
                      <Droplets className="w-4 h-4 text-blue-600" />
                      <span className="text-xs font-medium">{selectedProduct.washes} washes</span>
                    </div>
                    {selectedProduct.loadType && (
                      <div className="flex items-center space-x-2">
                        <Zap className="w-4 h-4 text-orange-600" />
                        <span className="text-xs font-medium">{selectedProduct.loadType}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}